import React from 'react';
import * as S from './styles';


const SmallLoader = () => {
	return <S.LoaderWrapper />;
};

export default SmallLoader;
